webpackJsonp([182150868854842],{

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(37);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _UserLinks = __webpack_require__(33);
	
	var _UserLinks2 = _interopRequireDefault(_UserLinks);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Privacy = function (_Component) {
	  _inherits(Privacy, _Component);
	
	  function Privacy() {
	    _classCallCheck(this, Privacy);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Privacy.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "about-container md-grid mobile-fix" },
	      _react2.default.createElement(
	        _Card2.default,
	        { className: "md-grid md-cell--8" },
	        _react2.default.createElement(
	          "div",
	          { className: "vPrivacy" },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "\u9690\u79C1\u653F\u7B56"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "vPrivacy-content" },
	            _react2.default.createElement(
	              "p",
	              { className: "vPrivacy-intro" },
	              "\u6B22\u8FCE\u4F7F\u7528\u677E\u679C\u7F51\u3002\u60A8\u5728\u4F7F\u7528\u6211\u4EEC\u7684\u670D\u52A1\u65F6\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002\u4E3A\u4E86\u4FDD\u969C\u60A8\u7684\u6743\u76CA\uFF0C\u8BA9\u60A8\u80FD\u5B89\u5FC3\u7684\u4F7F\u7528\u672C\u7F51\u7AD9\u548C\u5E94\u7528\uFF0C\u7279\u6B64\u5411\u60A8\u8BF4\u660E\u672C\u7F51\u7AD9\u7684\u9690\u79C1\u4FDD\u62A4\u653F\u7B56\u3002"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "vPrivacy-desc" },
	              _react2.default.createElement(
	                "dl",
	                null,
	                _react2.default.createElement(
	                  "dt",
	                  null,
	                  "\u5F15\u8A00"
	                ),
	                _react2.default.createElement(
	                  "dd",
	                  null,
	                  "\u677E\u679C\u7F51\u662F\u670D\u52A1\u4E8E\u6D77\u5916\u534E\u4EBA\u5171\u4EAB\u7269\u6D41\u7684\u5E94\u7528\u3002\u677E\u679C\u7F51\u5C0A\u91CD\u5E76\u4FDD\u62A4\u60A8\u7684\u9690\u79C1\u3002\u60A8\u4F7F\u7528\u6211\u4EEC\u7684\u670D\u52A1\uFF0C\u5373\u610F\u5473\u7740\u540C\u610F\u6211\u4EEC\u6309\u7167\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002"
	                )
	              ),
	              _react2.default.createElement(
	                "dl",
	                null,
	                _react2.default.createElement(
	                  "dt",
	                  null,
	                  "\u9690\u79C1\u6743\u4FDD\u62A4\u653F\u7B56\u7684\u4F7F\u7528\u8303\u56F4"
	                ),
	                _react2.default.createElement(
	                  "dd",
	                  null,
	                  "\u9690\u79C1\u6743\u4FDD\u62A4\u653F\u7B56\u5185\u5BB9\uFF0C\u5305\u62EC\u672C\u7F51\u7AD9\u5982\u4F55\u5904\u7406\u5728\u60A8\u4F7F\u7528\u7F51\u7AD9\u670D\u52A1\u65F6\u6536\u96C6\u5230\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002\u9690\u79C1\u4FDD\u62A4\u653F\u7B56\u4E0D\u9002\u7528\u4E8E\u672C\u7F51\u7AD9\u4EE5\u5916\u7684\u76F8\u5173\u8FDE\u63A5\u7F51\u7AD9\uFF0C\u4E5F\u4E0D\u9002\u7528\u4E8E\u975E\u672C\u7F51\u7AD9\u6240\u59D4\u6258\u6216\u53C2\u4E0E\u7BA1\u7406\u7684\u4EBA\u5458\u3002"
	                )
	              ),
	              _react2.default.createElement(
	                "dl",
	                null,
	                _react2.default.createElement(
	                  "dt",
	                  null,
	                  "\u4E2A\u4EBA\u4FE1\u606F\u7684\u6536\u96C6"
	                ),
	                _react2.default.createElement(
	                  "dd",
	                  null,
	                  "\u60A8\u5728\u7528\u5FAE\u4FE1\u767B\u5F55\u65F6\uFF0C\u5FAE\u4FE1\u5E73\u53F0\u5C06\u4F1A\u63D0\u4F9B\u5FAE\u4FE1\u7528\u6237\u5171\u4EAB\u4FE1\u606F\uFF0C\u5305\u62EC\u6635\u79F0\u548C\u6027\u522B\uFF0C\u4F46\u4E0D\u5305\u62EC\u5FAE\u4FE1\u53F7\u3002\u60A8\u5728\u6CE8\u518C\u677E\u679C\u8D26\u53F7\u7684\u65F6\u5019\uFF0C\u53EF\u4EE5\u63D0\u4F9B\u5FAE\u4FE1\u53F7\u3002\u6211\u4EEC\u5C06\u4F1A\u91C7\u96C6\u5E76\u5B58\u50A8\u60A8\u7684\u5FAE\u4FE1\u6635\u79F0\uFF0C\u6027\u522B\u548C\u5FAE\u4FE1\u53F7\u4FE1\u606F\uFF08\u5982\u679C\u60A8\u63D0\u4F9B\uFF09\u3002\u677E\u679C\u7F51\u8FD8\u4F7F\u7528AWS Analytics\u6765\u8BB0\u5F55\u7528\u6237\u7684\u4F4D\u7F6E\uFF0C\u6D4F\u89C8\u5668\u7C7B\u578B\u7B49\u4FE1\u606F\u3002"
	                )
	              ),
	              _react2.default.createElement(
	                "dl",
	                null,
	                _react2.default.createElement(
	                  "dt",
	                  null,
	                  "\u4E2A\u4EBA\u4FE1\u606F\u7684\u4F7F\u7528"
	                ),
	                _react2.default.createElement(
	                  "dd",
	                  null,
	                  "\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4EC5\u9650\u4E8E\u677E\u679C\u7F51\u4F7F\u7528\u4EE5\u4E0B\u7528\u9014: 1.\u9A8C\u8BC1\u7528\u6237\u8F93\u5165\u6570\u636E\u7684\u771F\u5B9E\u6027\uFF0C2.\u63D0\u4F9B\u66F4\u597D\u66F4\u7CBE\u51C6\u7684\u670D\u52A1\uFF0C3.\u9632\u6B62\u6076\u610F\u7528\u6237\u7684\u6B3A\u8BC8\u884C\u4E3A\u3002 \u672A\u7ECF\u60A8\u540C\u610F\uFF0C\u677E\u679C\u7F51\u4E0D\u4F1A\u4E0E\u7B2C\u4E09\u65B9\u5206\u4EAB\u548C\u4EA4\u6613\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002"
	                )
	              ),
	              _react2.default.createElement(
	                "dl",
	                null,
	                _react2.default.createElement(
	                  "dt",
	                  null,
	                  "\u4E2A\u4EBA\u4FE1\u606F\u7684\u5B89\u5168"
	                ),
	                _react2.default.createElement(
	                  "dd",
	                  null,
	                  "\u672C\u7F51\u7AD9\u4E3B\u673A\u8BBE\u6709\u9632\u706B\u5899\uFF0C\u4F7F\u7528SSL\u7B49\u5404\u9879\u5B89\u5168\u8BBE\u5907\u53CA\u63AA\u65BD\u3002\u901A\u8FC7\u8FD9\u4E9B\u4E25\u683C\u63AA\u65BD\u52AA\u529B\u4FDD\u62A4\u60A8\u7684\u4FE1\u606F\u4E0D\u88AB\u672A\u7ECF\u6388\u6743\u7684\u8BBF\u95EE\u3001\u4F7F\u7528\u6216\u6CC4\u6F0F\u3002"
	                )
	              ),
	              _react2.default.createElement(
	                "dl",
	                null,
	                _react2.default.createElement(
	                  "dt",
	                  null,
	                  "\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u4FDD\u62A4"
	                ),
	                _react2.default.createElement(
	                  "dd",
	                  null,
	                  "\u677E\u679C\u7F51\u975E\u5E38\u91CD\u89C6\u5BF9\u672A\u6210\u5E74\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u82E5\u60A8\u662F18\u5468\u5C81\u4EE5\u4E0B\u7684\u672A\u6210\u5E74\u4EBA\uFF0C\u5728\u4F7F\u7528\u524D\u4E8B\u5148\u53D6\u5F97\u60A8\u7684\u5BB6\u957F\u6216\u6CD5\u5B9A\u76D1\u62A4\u4EBA\u7684\u540C\u610F\u3002"
	                )
	              ),
	              _react2.default.createElement(
	                "dl",
	                null,
	                _react2.default.createElement(
	                  "dt",
	                  null,
	                  "\u9690\u79C1\u4FDD\u62A4\u7684\u4FEE\u6B63"
	                ),
	                _react2.default.createElement(
	                  "dd",
	                  null,
	                  "\u672C\u7F51\u7AD9\u9690\u79C1\u4FDD\u62A4\u653F\u7B56\u5E94\u9700\u6C42\u968F\u65F6\u4FEE\u6B63\uFF0C\u4FEE\u6B63\u540E\u7684\u6761\u6B3E\u5C06\u53CA\u65F6\u53D1\u5E03\u5230\u7F51\u7AD9\u4E0A\u3002"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_UserLinks2.default, { labeled: true, config: _SiteConfig2.default })
	        )
	      )
	    );
	  };
	
	  return Privacy;
	}(_react.Component);
	
	exports.default = Privacy;
	module.exports = exports["default"];

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Buttons = __webpack_require__(36);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	__webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserLinks = function (_Component) {
	  _inherits(UserLinks, _Component);
	
	  function UserLinks() {
	    _classCallCheck(this, UserLinks);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  UserLinks.prototype.getLinkElements = function getLinkElements() {
	    var userLinks = this.props.config.userLinks;
	    var labeled = this.props.labeled;
	
	    return userLinks.map(function (link) {
	      return _react2.default.createElement(
	        _Buttons2.default,
	        {
	          icon: !labeled,
	          flat: labeled,
	          secondary: true,
	          key: link.label,
	          iconClassName: link.iconClassName,
	          href: link.url
	        },
	        labeled ? link.label : ""
	      );
	    });
	  };
	
	  UserLinks.prototype.render = function render() {
	    var userLinks = this.props.config.userLinks;
	
	    if (!userLinks) {
	      return null;
	    }
	    return _react2.default.createElement(
	      "div",
	      { className: "user-links" },
	      this.getLinkElements()
	    );
	  };
	
	  return UserLinks;
	}(_react.Component);
	
	exports.default = UserLinks;
	module.exports = exports["default"];

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(16);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Privacy = __webpack_require__(323);
	
	var _Privacy2 = _interopRequireDefault(_Privacy);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacyPage = function (_Component) {
	  _inherits(PrivacyPage, _Component);
	
	  function PrivacyPage() {
	    _classCallCheck(this, PrivacyPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PrivacyPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "privacy-container" },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          "Privacy | " + _SiteConfig2.default.siteTitle
	        ),
	        _react2.default.createElement("link", { rel: "canonical", href: _SiteConfig2.default.siteUrl + "/about/" })
	      ),
	      _react2.default.createElement(_Privacy2.default, null)
	    );
	  };
	
	  return PrivacyPage;
	}(_react.Component);
	
	exports.default = PrivacyPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-jsx-b1fc580c6f2f5821cf98.js